<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import LandingMetric from '@/Pages/NewLanding/partials/LandingMetric.vue';
import LandingThing from '@/Pages/NewLanding/partials/LandingThing.vue';
import CheckIconListItem from '@/Pages/NewLanding/partials/CheckIconListItem.vue';
import LandingContactSection from '../Landing/LandingContactSection.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    props: {
        meta: Object,
    },
    components: {
        AppButton,
        LandingContactSection,
        LandingMetric,
        LandingThing,
        CheckIconListItem,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
<template>
    <div>
        <div class="text-6xl font-bold text-center mt-5 md:mt-16">
            {{ $t('landing.index.section01.title') }}
        </div>
        <div class="lg:mx-auto lg:max-w-5xl lg:px-8 mt-5 text-2xl">
            <p v-html="$t('landing.index.section01.description')"></p>
        </div>

        <div class="lg:mx-auto lg:max-w-5xl lg:px-8 text-lg">
            <div class="lg:px-8 px-4 mt-5">
                <div class="md:grid grid-cols-3 gap-4">
                    <div>
                        <img src="/img/new_landing/undraw_team-collaboration_phnf.svg" alt="" class="h-36" />
                    </div>
                    <div class="col-span-2">
                        <ul>
                            <li>
                                <CheckIconListItem> {{ $t('landing.index.section02.item1') }}</CheckIconListItem>
                            </li>
                            <li>
                                <CheckIconListItem> {{ $t('landing.index.section02.item2') }}</CheckIconListItem>
                            </li>
                            <li>
                                <CheckIconListItem> {{ $t('landing.index.section02.item3') }}</CheckIconListItem>
                            </li>
                            <li>
                                <CheckIconListItem> {{ $t('landing.index.section02.item4') }}</CheckIconListItem>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gray-100 mt-5">
            <div>&nbsp;</div>
            <div class="lg:mx-auto lg:max-w-5xl lg:px-8 mt-5 mb-3">
                <div class="text-3xl font-semibold">{{ $t('landing.index.section03.title') }}</div>
                <div class="px-16 py-10">
                    <div class="grid grid-cols-2 md:grid-cols-4 gap-16">
                        <LandingMetric
                            value="1"
                            :unit="$t('landing.index.section03.item1_unit')"
                            :description="$t('landing.index.section03.item1_description')"
                        />
                        <LandingMetric
                            value="40"
                            :unit="$t('landing.index.section03.item2_unit')"
                            :description="$t('landing.index.section03.item2_description')"
                        />
                        <LandingMetric
                            value="1"
                            :unit="$t('landing.index.section03.item3_unit')"
                            :description="$t('landing.index.section03.item3_description')"
                        />
                        <LandingMetric
                            value="120"
                            :unit="$t('landing.index.section03.item4_unit')"
                            :description="$t('landing.index.section03.item4_description')"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 mt-5">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-8">
                <LandingThing
                    img="/img/new_landing/t_school.png"
                    :title="$t('landing.index.section04.item1_title')"
                    :description="$t('landing.index.section04.item1_description')"
                />
                <LandingThing
                    img="/img/new_landing/t_math.png"
                    :title="$t('landing.index.section04.item2_title')"
                    :description="$t('landing.index.section04.item2_description')"
                    :url="meta.links.turing"
                />
                <LandingThing
                    img="/img/new_landing/t_gamification.png"
                    :title="$t('landing.index.section04.item3_title')"
                    :description="$t('landing.index.section04.item3_description')"
                />
                <LandingThing
                    img="/img/new_landing/t_activities.png"
                    :title="$t('landing.index.section04.item4_title')"
                    :description="$t('landing.index.section04.item4_description')"
                />
                <LandingThing
                    img="/img/new_landing/t_evaluation.png"
                    :title="$t('landing.index.section04.item5_title')"
                    :description="$t('landing.index.section04.item5_description')"
                />
                <LandingThing
                    img="/img/new_landing/t_earth.png"
                    :title="$t('landing.index.section04.item6_title')"
                    :description="$t('landing.index.section04.item6_description')"
                    :url="meta.links.esfera"
                />
                <LandingThing
                    img="/img/new_landing/t_groups.png"
                    :title="$t('landing.index.section04.item7_title')"
                    :description="$t('landing.index.section04.item7_description')"
                    :url="meta.links.nexa"
                />
                <LandingThing
                    img="/img/new_landing/t_ai.png"
                    :title="$t('landing.index.section04.item8_title')"
                    :description="$t('landing.index.section04.item8_description')"
                />
            </div>
        </div>

        <div class="pb-36">
            <div class="bg-gray-100 w-full mt-5 h-40"></div>
            <div class="lg:mx-auto lg:max-w-7xl lg:px-8 -m-36">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <InertiaLink :href="meta.links.teachers">
                        <div class="flex justify-center">
                            <img src="/img/new_landing/undraw_all-the-data_5lil.svg" alt="" class="h-48" />
                        </div>
                        <div class="text-center text-indigo-500 text-lg mt-3">
                            <AppButton element="InertiaLink" :href="meta.links.teachers" desired-action>
                                {{ $tc('messages.teachers', 1) }}
                            </AppButton>
                        </div>
                    </InertiaLink>

                    <div>
                        <div class="flex justify-center">
                            <img src="/img/new_landing/undraw_reading_atc8.svg" alt="" class="h-48" />
                        </div>
                        <div class="text-center text-gray-500 text-lg mt-3">
                            {{ $t('messages.student') }}
                        </div>
                    </div>

                    <div>
                        <div class="flex justify-center">
                            <img src="/img/new_landing/undraw_certificate_71gt.svg" alt="" class="h-48" />
                        </div>
                        <div class="text-center text-gray-500 text-lg mt-3">
                            {{ $t('messages.business') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--    contact-->
        <LandingContactSection />
    </div>
</template>
